<section>
  <app-site-config-form id="{{ id }}"></app-site-config-form>
</section>
